import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { ConsignmentSerialNumberLine, ConsignmentService } from '@app/services/consignment.service';

@Component({
  selector: 'tt-consignment-serial-number',
  templateUrl: './consignment-serial-number.component.html',
  styleUrls: ['./consignment-serial-number.component.css'],
  standalone: false,
})
export class ConsignmentSerialNumberComponent implements OnInit {
    public page?: ConsignmentSerialNumberLine[];
    public loading = false;
    public saving = false;

    constructor(
        private consignment: ConsignmentService,
        private modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async ngOnInit(): Promise<void> {
        const keyno = this.navigator?.params['consignment_keyno'];
        if (typeof keyno !== 'string' && typeof keyno !== 'number') return;
        this.loading = true;
        try {
            this.page = await this.consignment.getSerialNumberLines({ consignment_keyno: keyno });
        } finally {
            this.loading = false;
        }
    }

    public async save(): Promise<void> {
        if (!this.page || this.loading || this.saving) return;
        this.saving = true;
        try {
            const response = await this.consignment.saveSerialNumbers(this.page);
            if (String(response?.errorcode) === '0') {
                await this.navigator?.back();
            } else {
                await this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: response?.errormessage ?? '' });
            }
        } finally {
            this.saving = false;
        }
    }

}
